<script>
import BOForm from '../../baseComponents/boForm'
import SchedulerForm from './scheduler.form.vue'
import { themes, getMessageHint } from '../../variables'
export default {
	extends: BOForm,
	data() {
		return {
			items: [
				{ label: 'Nom', value: 'name', type: 'text', required: true },
				{ label: 'Clef', value: 'key', type: 'text', required: true, disabled: false },
				{ label: 'Identifiant botnation', value: 'webSiteId', type: 'text', required: true },
				{ label: 'Emetteur', value: 'emetteur', type: 'text', required: false },
				{
					label: 'Asv',
					value: 'asvString',
					type: 'text-area',
					hint: 'Nom des ASV séparé par des ;',
					placeholder: 'Nom des ASV séparé par des ;',
				},
				{ label: 'Bot Asko', value: 'isAsko', type: 'checkbox' },
				{ label: 'Sauvegarde du temps de passage', value: 'saveNavigationTime', type: 'checkbox', disabled: false },
				{ label: 'Clef api', value: 'apiKey', type: 'text', required: true },
				{ label: 'Utilise des licences', value: 'licensed', type: 'checkbox' },
				{
					label: 'Id sib nouvel utilisateur',
					value: 'newUserSibId',
					type: 'number',
					hide: (value, bot) => {
						return !!bot && bot.isAsko
					},
				},
				{
					label: "Id sib rappel (demandé par l'utilisateur sur le chatbot)",
					value: 'reminderSibId',
					type: 'number',
					required: true,
					hide: (value, bot) => {
						return !!bot && bot.isAsko
					},
				},
				{
					label: 'Id sib rappel automatique',
					value: 'reminderScheduleSibId',
					type: 'number',
					required: true,
					hide: (value, bot) => {
						return !!bot && bot.isAsko
					},
				},
				// { label: 'Signature',
				//   value: 'signature',
				//   type: 'sub-doc',
				//   hide: (scheduler, bot) => {
				//     return !bot || !bot.isAsko
				//   },
				//   required: false,
				//   items: [
				//     { label: 'Nom', value: 'name', type: 'text', required: true },
				//     { label: 'Description', value: 'description', type: 'text', required: true },
				//     {
				//       label: 'Envoyer les documents à',
				//       value: 'contact',
				//       type: 'text',
				//       required: true,
				//     					rules: [
				//     						v => {
				//     							const pattern = /^[a-zA-Z0-9]([.\-_]?[a-zA-Z0-9])*@[a-zA-Z0-9]([.\-_]?[a-zA-Z0-9])*.[a-zA-Z]{2,4}$/
				//     							return pattern.test(v) || 'email invalide'
				//     						}
				//     					]
				//             },
				//     { label: 'Template envoyé', value: 'template', type: 'number', required: true },
				//     {
				//       label: 'Documents',
				//       value: 'documents',
				//       type: 'sub-array',
				//       items: [
				//         {
				//           label: 'Fichier',
				//           value: 'file',
				//           type: 'file',
				//           required: true
				//         },
				//         { label: 'Nom du document', value: 'name', type: 'text', rules: [(v) => (v && v.substring(v.length - 4, v.length) === '.pdf') || 'format .pdf'] },
				//         { label: 'Page à signer', value: 'page', type: 'number', required: true, rules: [(v) => v > 0 || '> à 0'] },
				//         { label: 'Position', value: 'position', type: 'text', required: true },
				//         { label: 'Mention 1', value: 'mention', type: 'text', required: false },
				//         { label: 'Mention 2', value: 'mention2', type: 'text', required: false }
				//       ],
				//       required: true
				//     }
				//   ]
				// },

				{
					label: 'Variables',
					value: 'variables',
					type: 'sub-array',
					items: [
						{ label: 'Nom', value: 'label', type: 'text', required: true },
						{ label: 'Valeur', value: 'value', type: 'text', required: true },
					],
				},
				{
					label: 'Themes',
					value: 'themes',
					type: 'multi-select',
					multiple: true,
					values: themes,
					hide: (value, bot) => {
						return !!bot && !bot.isAsko
					},
				},
				{
					label: "Activer l'Envoi automatique",
					value: 'schedulerActivated',
					type: 'checkbox',
				},
				{
					label: 'Envoi automatique',
					value: 'schedulers',
					type: 'custom',
					component: SchedulerForm,
					hide: (scheduler, bot) => {
						return !!bot && !bot.schedulerActivated
					},
				},
			],
		}
	},
	methods: {
		readFile(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.readAsDataURL(file)
				reader.onload = () => resolve(reader.result.replace('data:application/pdf;base64,', ''))
				reader.onerror = (error) => reject(error)
			})
		},
		async post() {
			let subBots = this.model.subBots
			delete this.model.subBots
			let schedulers = this.model.schedulers
			delete this.model.schedulers

			let file = this.model.licenses
			this.model.licenses = undefined
			delete this.model.licenses
			// if (this.model.signature && this.model.signature.documents) {
			//   for (let i = 0; i < this.model.signature.documents.length; i++) {
			//     if (this.model.signature.documents[i].file) {
			//       this.model.signature.documents[i]j_ç.content = await this.readFile(this.model.signature.documents[i].file)
			//     }
			//   }
			// }

			if (this.model.asvString) {
				this.model.asvs = this.model.asvString
					.split(/;/g)
					.map((asv) => asv.trim())
					.filter((asv) => !!asv)
				delete this.model.asvString
			}
			const res = await this.axios.post('bots', { ...this.model })

			if (this.model.asvString) {
				this.model.asvString = this.model.asvs.join('; ')
			}
			if (file) {
				this.importLicenses(file, res.data._id)
			}

			if (subBots) {
				for (let i = 0; i < subBots.length; i++) {
					subBots[i] = (await this.axios.post('subBots', { ...subBots[i], bot: res.data._id })).data
				}
				this.model.subBots = subBots
			}

			// convert _id <=> name
			if (schedulers) {
				this.model.schedulers = schedulers.map((scheduler) => ({
					...scheduler,
					subBots: scheduler.subBots.map((subBot) => {
						const foundSubBot = subBots.find((sb) => sb.name === subBot._id)

						return {
							...subBot,
							_id: foundSubBot ? foundSubBot._id : undefined,
						}
					}),
				}))

				await this.axios.put('bots/' + res.data._id, {
					schedulers: this.model.schedulers,
				})
			}
		},
		async put() {
			let file = this.model.licenses
			this.model.licenses = undefined
			delete this.model.licenses

			// if (this.model.signature && this.model.signature.documents) {
			//   for (let i = 0; i < this.model.signature.documents.length; i++) {
			//     if (this.model.signature.documents[i].file) {
			//     this.model.signature.documents[i].content = await this.readFile(this.model.signature.documents[i].file)
			//     }
			//   }
			// }

			await this.axios.put('bots/' + this.model._id, {
				name: this.model.name,
				// signature: this.model.signature,
				webSiteId: this.model.webSiteId,
				apiKey: this.model.apiKey,
				url: this.model.url,
				isAsko: this.model.isAsko,
				newUserSibId: this.model.newUserSibId,
				reminderScheduleSibId: this.model.reminderScheduleSibId,
				reminderSibId: this.model.reminderSibId,
				licensed: this.model.licensed,
				schedulerActivated: this.model.schedulerActivated,
				schedulers: this.model.schedulers,
				themes: this.model.themes,
				variables: this.model.variables,
				emetteur: this.model.emetteur,
				asvs: this.model.asvString
					? this.model.asvString
							.split(/;/g)
							.map((asv) => asv.trim())
							.filter((asv) => !!asv)
					: [],
			})

			if (file) {
				this.importLicenses(file, this.model._id)
			}
		},
	},
	watch: {
		model() {
			if (!!this.model && !!this.model._id) {
				if (this.model.asvs) {
					this.model.asvString = this.model.asvs.join('; ')
				}

				this.$set(this.items[1], 'disabled', true)
				this.$set(this.items[6], 'disabled', true)

				this.items.splice(2, 0, {
					label: "Lien d'inscription",
					value: 'subscriptionLink',
					type: 'text',
					required: false,
					disabled: true,
				})
			} else {
				if (!this.items.find((item) => item.value === 'subBots')) {
					this.items.splice(12, 0, {
						label: 'Groupes',
						value: 'subBots',
						type: 'sub-array',
						items: [
							{ label: 'Nom', value: 'name', type: 'text', required: true },
							{ label: 'Reference', value: 'ref', type: 'text', required: false },
							{ label: 'Clef', value: 'key', type: 'text', required: true },
							{
								label: 'Message',
								value: 'message',
								hint: getMessageHint(this.model.isAsko),
								type: 'text-area',
								required: true,
								rules: [
									(v) => !!v || 'Message requis',
									// (v) => (!!v && v.indexOf('{link}') !== -1) || "{link} n'est pas présent",
								],
								grid: { xs12: true },
							},
						],
					})
				}
			}
		},
	},
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/bots/bot.form.vue